import { GIFT_PASS_TAG_ICONS, type GiftPassTagIcon } from '@bonsai/shared';

import { GIFT_PASS_TAG_ICON_GLYPHS } from '../tags/GiftPassTag';

import './gift-pass-bundle-editor.css';

export function BundleTagIconPalette({ onPick }: { onPick: (icon: GiftPassTagIcon) => void }) {
  return (
    <div className="gpb-ed-icons">
      <p id="bundle-icons-hint">
        Type an icon code in square brackets, or click one to insert it at the cursor. The purchase
        page shows the icon in its place.
      </p>
      <div role="group" aria-labelledby="bundle-icons-hint" className="gpb-ed-icon-list">
        {GIFT_PASS_TAG_ICONS.map((icon) => {
          const Glyph = GIFT_PASS_TAG_ICON_GLYPHS[icon];
          return (
            <button
              key={icon}
              type="button"
              className="gpb-ed-icon-chip"
              aria-label={`Insert [${icon}]`}
              // Keeps the tag input focused so its caret is where the code goes.
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => onPick(icon)}
            >
              <Glyph size={13} aria-hidden />
              <code>[{icon}]</code>
            </button>
          );
        })}
      </div>
    </div>
  );
}
